import { Component, OnInit, Renderer2 } from '@angular/core';
import {Location} from '@angular/common';
// import { PaymentStatusModelComponent } from '../../SFM_/payment/payment-status-model/payment-status-model.component';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { DatabaseService } from 'src/app/_services/database.service';
import swal from 'sweetalert';
import { RedeemRequestStatusModelComponent } from '../redeem-status-model/status-model.component';
import { GiftStatusModelComponent } from '../gift-status-model/status-model.component';


@Component({
  selector: 'app-redeem-req-list',
  templateUrl: './redeem-req-list.component.html'
})
export class RedeemReqListComponent implements OnInit {
  
  data:any=[];
  dataNotFound=false
  reqSent=false
  
  
  typeName:any 
  constructor(
    private _location: Location,
    public dialog: MatDialog,
    public db:DatabaseService,
    private render: Renderer2,
    ) {  
      
    }
    ngOnInit() {
      this.db.getStates();
      this.filter.state_name = '';
      this.filter.gift_status='';
      this.filter.redeem_status = '';
      this.getCounters();
      this.todayDate =  moment(new Date ()).format('YYYY-MM-DD')
    }
    tabActiveType:any={};
    tabActive:any='All'
    todayDate :any
    pageNo:any = 1;
    tempPageNo = 1;
    totalPages:any
    start:any = 0;
    limit:any = 50;
    totalLength:any;
    filter:any={};
    getData(){
      this.dataNotFound = false;
      this.reqSent = false;
      this.filter.redeem_status = this.tabActive == 'All' ? '' : this.tabActive;
      let reqData = {
        limit : this.limit,
        start : this.start,
        filter : this.filter
      }
      this.db.presentLoader();
      this.db.postReq(reqData,'redeem_request/list').subscribe(resp=>{
        this.reqSent = true;
        if(resp['status'] == 'success'){
          this.data = resp['result'].data;
          if(!this.data.length) this.dataNotFound = true;
          this.totalLength = resp['result'].totalCount;
          this.totalPages = Math.ceil(this.totalLength / this.limit);
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        
      })
    }
    counters:any=[];
    getCounters(){
      
      this.db.presentLoader();
      this.db.postReq({},'redeem_request/list_count').subscribe(resp=>{
        this.reqSent = true;
        if(resp['status'] == 'success'){
          // resp['result'].data.map(r=>{
          this.counters= resp['result'].data
          // })
          console.log(this.counters);
          // this.tabActive = resp['result'].data[0].name; 
          this.getData();
          
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        this.db.errHandler(err);
      })
    }
    pagination(action){
      
      if(action == 'pageNo'){
        if(this.pageNo > 0 && this.pageNo <=this.totalPages){
          this.start = this.limit*(this.pageNo-1)
        }else{
          this.pageNo = Math.ceil(this.totalLength / this.data.length);
        }
      }
      else if(action=='next'){
        
               if(this.totalLength == (this.start+this.data.length)) return;

        this.start = this.start+this.limit
        this.pageNo ++ ;
      }else{
        if(this.pageNo == 1) return
        this.start = this.start-this.limit
        this.pageNo -- ;
      }
      this.getData();
      this.tempPageNo = this.pageNo
    }
    refresh(){
      this.start = 0;
      this.limit = 50;
      this.filter = {};
      this.getData();
    }
    delete(data){
      swal({
        title: "Are you sure?",
        text: "You want to delete this "+this.typeName+"!",
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
        dangerMode: true,
      })
      .then((willDelete) => {        
        if (willDelete) {
          this.db.presentLoader();
          data.customer_id = data.encrypt_id;
          this.db.postReq(data,'dis_network/delete').subscribe(resp=>{
            if(resp['status'] == 'success'){
              this.getData();
              swal("Deleted", {
                icon: "success",
              });
            }else{
              if(resp['message']=='Invalid token'){
                this.db.sessionExpire();
                return;
              }
              this.db.presentAlert(resp['status'],resp['message'])
            }
          })
          
        } else {
          swal("Your data is safe!");
        }
      });
    }


      deleteGift(data){
        console.log(data);
        swal({
          title: "Are you sure?",
          text: "You want to delete this",
          icon: "warning",
          buttons: ["Cancel", "Confirm"],
          dangerMode: true,
        })
        .then((willDelete) => {        
          if (willDelete) {
            this.db.presentLoader();
            
            this.db.postReq(data,'redeem_request/delete_redeem_request').subscribe(resp=>{
              if(resp['status'] == 'success'){
                this.getData();
                swal(resp['message']);
              }else{
                if(resp['message']=='Invalid token'){
                  this.db.sessionExpire();
                  return;
                }
                this.db.presentAlert(resp['status'],resp['message'])
              }
            })
            
          } else {
            swal("Your data is safe!");
          }
        });
      }
    backClicked() {
      this._location.back();
    } 
    status:boolean = false
    
    toggleNav() 
    {
      this.status = !this.status;
      if(this.status) {
        this.render.addClass(document.body, 'toggle-active-tlp');
      }
      else {
        this.render.removeClass(document.body, 'toggle-active-tlp');
      }
    }
    openStatusDialog(data:any): void {
      console.log('openStatusDialog',data);
      // this.db.redeemRequestData = data;
      const dialogRef = this.dialog.open(RedeemRequestStatusModelComponent, {
        width: '400px',
        autoFocus: false,
        data: data
      });
      
      dialogRef.afterClosed().subscribe(result => {
        this.getCounters();     
      });
    }
    openGiftDialog(data): void {
      console.log(data);
      // this.db.redeemRequestData = data;
      const dialogRef = this.dialog.open(GiftStatusModelComponent, {
        width: '400px',
        autoFocus: false,
        data: data
      });
      
      dialogRef.afterClosed().subscribe(result => {
        this.getCounters();     
      });
    }
    loginStatusChange(data){
      swal({
        title: "Are you sure?",
        text: data.login_status == 1  ? "You want to make this Activate Login!" : "You want to make this Inactivate Login!",
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
        dangerMode: true,
      })
      .then((willDelete) => {        
        if (willDelete) {
          this.db.presentLoader();
          data.login_status = data.login_status == 0 ? 1 : 0;
          data.customer_id = data.encrypt_id;
          this.db.postReq(data,'dis_network/login_status').subscribe(resp=>{
            if(resp['status'] == 'success'){
              swal(data.login_status == 0 ? "Inactive!" : "Active", {
                icon: "success",
              });
              this.getData();
            }else{
              if(resp['message']=='Invalid token'){
                this.db.sessionExpire();
                return;
              }
              this.db.presentAlert(resp['status'],resp['message'])
            }
          })
          
        } else {
          swal("Your data is safe!");
        }
      });
    }
    downloadExcel(){
      this.filter.gift_status = this.tabActive == 'All' ? '' : this.tabActive;
      let reqData = {
        filter : this.filter
      }
      this.db.presentLoader();
      this.db.postReq(reqData,'redeem_request/list/excel').subscribe(resp=>{
        this.reqSent = true;
        if(resp['status'] == 'success'){
          this.db.exportAsExcelFile(resp['result'].data,resp['result'].file_name ? resp['result'].file_name : 'exported_data')
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        
      })
    }
  }
  
  
  
  